class RemoveFileReq{
    string = null;
    int = null;
    pagingParams = {
      pageNumber: 0,
      pageSize: 0
    };
}

export default RemoveFileReq